"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _raven_client = require("../legacy/helpers/raven_client");

var _raven_client2 = _interopRequireDefault(_raven_client);

var _omit = require("lodash/omit");

var _omit2 = _interopRequireDefault(_omit);

var _pick = require("lodash/pick");

var _pick2 = _interopRequireDefault(_pick);

var _ravenForRedux = require("raven-for-redux");

var _ravenForRedux2 = _interopRequireDefault(_ravenForRedux);

var _reduxWindowsize = require("redux-windowsize");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// These action types will not be added to breadcrumbs, since they would clutter the logs
var breadcrumbActionBlacklist = [];

/**
 * Whitelist known small pieces of state
 */
/**
 * Exports a Redux middleware that logs actions & store state to Sentry.
 *
 */

var stateTransformer = function stateTransformer(state) {
	var filtered = (0, _pick2.default)(state, ["plugin", "search", "user", "apiResponse", "stripe", "download", "experiments", "editor", _reduxWindowsize.REDUCER_KEY]);

	filtered = (0, _omit2.default)(filtered, ["editor.svg", "download.pendingDownload.raw_svg"]);

	return filtered;
};
/**
 * Filters out some of the larger pieces of actions
 */
var actionTransformer = function actionTransformer(actions) {
	return (0, _omit2.default)(actions, ["icons", "response", "asyncDispatch"]);
};
var filterBreadcrumbActions = function filterBreadcrumbActions(action) {
	return !breadcrumbActionBlacklist.includes(action.type);
};

exports.default = (0, _ravenForRedux2.default)(_raven_client2.default, {
	stateTransformer: stateTransformer,
	actionTransformer: actionTransformer,
	filterBreadcrumbActions: filterBreadcrumbActions
});